import apollo from '@/graphql'

import BrandCategoriesQuery from '@/graphql/brand/BrandCategoriesQuery.gql'
import BrandsQuery from '@/graphql/brand/BrandsQuery.gql'

// initial state
const state = {
  brandCategories: [],
  brands: [],
}

// getters
const getters = {
  brandCategories: st => st.brandCategories,

  brands: st => st.brands,
}

// mutations
const mutations = {
  setBrandCategories(st, brandCategories) {
    state.brandCategories = brandCategories
  },

  setBrands(st, brands) {
    state.brands = brands
  },
}

// actions
const actions = {
  loadBrandCategories({ commit }) {
    apollo.defaultClient.watchQuery({
      query: BrandCategoriesQuery,
    }).subscribe(({ data: { brandCategories } }) => {
      commit('setBrandCategories', brandCategories)
    })
  },

  loadBrands({ commit }) {
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: BrandsQuery,
    }).subscribe(({ data: { brands } }) => {
      commit('setBrands', brands)
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/brand/BrandList.js